import { Sparkles } from "lucide-react";
import { sanitizeCoachMessageContent } from "@/lib/coachChatMessageContent";
import { cn } from "@/lib/utils";
import { ChatMarkdownBody } from "@/components/chat/ChatMarkdownBody";

interface ChatMessageBubbleProps {
  content: string;
  role: "user" | "assistant";
  className?: string;
  showAssistantAvatar?: boolean;
}

export function ChatMessageBubble({
  content,
  role,
  className,
  showAssistantAvatar = false,
}: ChatMessageBubbleProps) {
  const isUser = role === "user";
  // Strip approval markers at render time as a fallback for messages hydrated from
  // persisted history (localStorage / coach_chat_messages) which may still contain them.
  // Live stream messages are also stripped at source in useCoachChat.ts.
  const cleanedContent = sanitizeCoachMessageContent(content);

  if (isUser) {
    return (
      <div
        className={cn(
          "px-3 py-2 rounded-2xl rounded-br-md text-sm bg-primary text-primary-foreground",
          className
        )}
      >
        {cleanedContent}
      </div>
    );
  }

  return (
    <div className="flex items-start gap-2">
      {showAssistantAvatar ? (
        <div className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-violet-500 to-purple-600 text-white">
          <Sparkles className="h-3.5 w-3.5" />
        </div>
      ) : null}
      <div
        className={cn(
          "px-3 py-2 rounded-2xl rounded-bl-md text-sm bg-card border border-border text-foreground",
          className
        )}
      >
        <ChatMarkdownBody content={cleanedContent} />
      </div>
    </div>
  );
}
